import * as ko from 'knockout';

import { MaybeKO } from '../utils/ko_utils';
import { DynamicAttribute } from '../models/attribute_meta';
import { viewImages } from '../components/view_image';
import { viewVideo } from '../components/view_video';

let template = require('raw-loader!../../templates/components/attribute_value.html').default;

const MEDIA_TYPES = {
  VIDEO: 'video',
  PICTURE: 'picture',
  MULTI_PICTURES: 'multi_pictures',
} as const;

type MediaType = (typeof MEDIA_TYPES)[keyof typeof MEDIA_TYPES];

class AttributeValue {
  attribute: MaybeKO<DynamicAttribute>;
  enable: MaybeKO<boolean>;

  constructor(params: { attribute: MaybeKO<DynamicAttribute>; enable?: MaybeKO<boolean> }) {
    this.attribute = params.attribute;
    this.enable = params.enable === undefined ? true : params.enable;
  }
  openMediaFromAttribute = (type: MediaType, url: string | string[], event: Event) => {
    event.stopPropagation();
    if (!url) {
      return;
    }
    if (type === MEDIA_TYPES.VIDEO) {
      viewVideo(url as string);
    } else if (type === MEDIA_TYPES.PICTURE) {
      viewImages([url as string]);
    } else {
      viewImages(url as string[]);
    }
  };
}

ko.components.register('attribute-value', {
  viewModel: AttributeValue,
  template: template,
});
